const BootLoader = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#1a1a1a",
      color: "rgba(255,255,255,0.88)",
    }}
    role="status"
    aria-live="polite"
  >
    <div
      className="spinner-border text-primary"
      style={{ width: "2.5rem", height: "2.5rem" }}
      aria-hidden="true"
    />
    <span className="sr-only">Loading…</span>
  </div>
);

export default BootLoader;
